<template>
  <MRow>
    <MCol :size="6">
      <FlotoFormItem
        id="start-at-picker"
        rules="required"
        :label="$t('start_at', { type: '' })"
      >
        <FlotoDatePicker
          v-if="!disabled"
          v-model="schedule.startAt"
          :min-date="Moment().valueOf()"
        />
        <template v-else>
          <span v-if="schedule.startAt">
            {{ schedule.startAt | datetime }}
          </span>
          <span v-else>---</span>
        </template>
      </FlotoFormItem>
    </MCol>
  </MRow>
</template>

<script>
import Moment from 'moment'
export default {
  name: 'OnceInput',
  model: { event: 'change' },
  props: {
    value: { type: Object, default: undefined },
    disabled: { type: Boolean, default: false },
  },
  data() {
    this.Moment = Moment
    return {}
  },
  computed: {
    schedule: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('change', v)
      },
    },
  },
}
</script>
